import Icon from "components/Icon/Icon";
import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";

interface ZoneProps {
  $isDragging: boolean;
}

export const Zone = styled.div<ZoneProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 28px 16px;
  text-align: center;
  border: 1px dashed
    ${({ theme, $isDragging }) =>
      $isDragging ? theme.primary : theme.formBorder};
  border-radius: 7px;
  background-color: ${({ theme, $isDragging }) =>
    $isDragging ? theme.primary10 : theme.dropdownBg};
  transition:
    border-color 0.15s,
    background-color 0.15s;
`;

export const ZoneTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ZoneIcon = styled(Icon)`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.primary};
`;

// The 64px loader drawn in the icon's box.
export const ZoneSpinner = styled(PreLoader)`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin: 0;
  transform-origin: 0 0;
  transform: scale(0.375);
`;

export const ZoneText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.textMain};
`;

export const ZoneHint = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.7;
  color: ${({ theme }) => theme.textSecondary};
`;
